<template>
    <div class="mobile">
        <!-- <div class="mobile-top-container"> -->
        <div class="mobile-top mobile-flex-sb mobile-content">
            <img class="logo-top" src="../../../assets/image/mobile/logo-top.png" />
            <div class="top-tabs" @click.stop="onClickTab">
                <img class="top-tabs" src="../../../assets/image/mobile/tabs.png" :class="{ list: show }" />
                <img class="top-tabs" src="../../../assets/image/mobile/del.png" :class="{ close: !show }" />
                <div class="mobile-menus" v-show="!show">
                    <div class="mobile-menus-item">
                        <a href="#about">关于我们</a>
                    </div>
                    <div class="mobile-menus-item">
                        <a href="#mobile-scope">业务范围</a>
                    </div>
                    <div class="mobile-menus-item">
                        <a href="#mobile-footer">联系我们</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-banner">
            <van-swipe class="my-swipe" :autoplay="3000" :duration="1000" :height="211">
                <van-swipe-item v-for="(items, index) in banners" :key="index">
                    <a :href="items.linkUrl" target="_blank">
                        <img :src="items.linkImg" />
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- </div> -->

        <div class="mobile-cont">
            <div class="mobile-content">
                <!-- 关于我们 -->
                <div id="about" class="mobile-about">
                    <div class="mobile-about-top">
                        <div class="text-bg">ABOUT US</div>
                        <div class="text">关于我们</div>
                        <div class="xian"></div>
                    </div>
                    <div class="about-cont">
                        <div class="fuwenben" v-html="about.content"></div>
                        <img :src="about.image" />
                    </div>
                </div>
                <!-- 业务范围 -->
                <div id="mobile-scope" class="mobile-scope">
                    <div class="mobile-about-top">
                        <div class="text-bg">BUSINESS SCOPE</div>
                        <div class="text">业务范围</div>
                        <div class="xian"></div>
                    </div>
                    <div class="scope-cont">
                        <!-- 签约作品 -->
                        <div class="sign" style="margin-top: 0">
                            <div class="mobile-sign-top">
                                <span>
                                    <span>{{ desc.comic.configName }}</span>
                                    <img src="../../../assets/image/mobile/titbg.png" />
                                </span>
                            </div>
                            <div class="sign-tit">{{ desc.comic.configContent }}</div>
                            <div class="sign-cont" v-for="(items, index) in signProduct" :key="index">
                                <div class="sign-item" v-if="index % 2 == 0">
                                    <a :href="items.audioUrl" target="_blank">
                                        <div class="comic-img">
                                            <img :src="items.comicImg" />
                                        </div>
                                    </a>
                                    <div class="sign-right">
                                        <div class="signr-tit">{{ items.comicTitle }}</div>
                                        <div class="sign-text" v-html="items.synopsis">
                                            <!-- {{ items.synopsis }} -->
                                        </div>
                                    </div>
                                </div>
                                <div class="sign-item" v-else>
                                    <div class="sign-right">
                                        <div class="signr-tit">{{ items.comicTitle }}</div>
                                        <div class="sign-text" v-html="items.synopsis">
                                            <!-- {{ items.synopsis }} -->
                                        </div>
                                    </div>
                                    <a :href="items.audioUrl" target="_blank">
                                        <div class="comic-img">
                                            <img :src="items.comicImg" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- 动态漫画 -->
                        <div class="dynamic">
                            <div class="mobile-sign-top">
                                <span>
                                    <span>{{ desc.motion_comic.configName }}</span>
                                    <img src="../../../assets/image/mobile/titbg.png" />
                                </span>
                            </div>
                            <div class="sign-tit">{{ desc.motion_comic.configContent }}</div>
                            <van-tabs
                                v-model="active"
                                color="#F1592A"
                                line-height="2"
                                title-active-color="#F1592A"
                                title-inactive-color="#666"
                            >
                                <van-tab :title="items.typeName" v-for="(items, index) in comicsTabs" :key="index">
                                    <div class="dynamic-container">
                                        <div
                                            class="dynamic-container-item"
                                            v-for="(row, i) in items.pageComicList.rows"
                                            :key="i"
                                        >
                                            <a :href="row.audioUrl" target="_blank">
                                                <div class="motion-img">
                                                    <img :src="row.motionComicImg" alt="" />
                                                </div>
                                                <div class="dynamic-title">{{ row.motionComicTitle }}</div>
                                                <div class="dynamic-circle">
                                                    <svg-icon iconClass="play" />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </van-tab>
                            </van-tabs>
                        </div>
                        <!-- 广播剧 -->
                        <div class="drama">
                            <div class="mobile-sign-top">
                                <span>
                                    <span>{{ desc.drama.configName }}</span>
                                    <img src="../../../assets/image/mobile/titbg.png" />
                                </span>
                            </div>
                            <div class="sign-tit">{{ desc.drama.configContent }}</div>
                            <div class="drama-container">
                                <div class="drama-container-item" v-for="(items, index) in dramas" :key="index">
                                    <a :href="items.audioUrl" target="_blank">
                                        <img :src="items.dramaImg" alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- 周边 -->
                        <div class="surrounding">
                            <div class="mobile-sign-top">
                                <span>
                                    <span>{{ desc.products.configName }}</span>
                                    <img src="../../../assets/image/mobile/titbg.png" />
                                </span>
                            </div>
                            <div class="sign-tit">{{ desc.products.configContent }}</div>
                            <van-swipe class="surrounding-swipe" :autoplay="3000" :duration="1000" :height="211">
                                <van-swipe-item v-for="(items, index) in surrounding" :key="index">
                                    <a :href="items.linkUrl" target="_blank">
                                        <img :src="items.linkImg" />
                                    </a>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <div id="mobile-footer" class="mobile-footer">
                <div class="mobile-footer-content">
                    <img src="@/assets/image/footer_logo.png" alt="" />
                    <div class="mobile-footer-right">
                        <div class="footer-tab">
                            <div class="footer-tab-item" v-for="(items, index) in links" :key="index">
                                <a :href="items.linkUrl" target="_blank">
                                    <img :src="items.linkImg" alt="" />
                                    <span>{{ items.linkName }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="contact-container">
                            <div class="contact-left">
                                <div class="contact-title">联系我们</div>
                                <div class="contact-item">
                                    <svg-icon iconClass="mail" />
                                    <span>{{ baseInfo.email.configContent }}</span>
                                </div>
                                <div class="contact-item">
                                    <svg-icon iconClass="phone" />
                                    <span>{{ baseInfo.phone.configContent }}</span>
                                </div>
                                <div class="contact-item">
                                    <svg-icon iconClass="address" />
                                    <span>{{ baseInfo.address.configContent }}</span>
                                </div>
                            </div>
                            <div class="contact-right">
                                <img src="@/assets/image/footer_contact.png" alt="" />
                                <div class="join-title">加入我们</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobile-footer-line">
                    <div>{{ baseInfo.copyright_information.configContent }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    findBanner,
    findMobileAbout,
    findSignProductList,
    findMotionComicList,
    findDramaList,
    findSurrounding,
    findLinkList,
    findDesc,
    findBaseInfo,
} from '@/api/home'
export default {
    name: 'MoblieHome',
    data() {
        return {
            show: true,
            active: 0,
            banners: [],
            about: {
                content: '',
                image: '',
            },
            signProduct: [],
            comicsTabs: [],
            dramas: [],
            surrounding: [],
            links: [],
            desc: {
                comic: {
                    configName: '',
                    configContent: '',
                },
                motion_comic: {
                    configName: '',
                    configContent: '',
                },
                drama: {
                    configName: '',
                    configContent: '',
                },
                products: {
                    configName: '',
                    configContent: '',
                },
            },
            baseInfo: {
                email: {},
                phone: {},
                address: {},
                archival_information: {},
                copyright_information: {},
                wechat: {},
                web_name: {},
                url: {},
            },
        }
    },
    created() {
        this.findBanner()
        this.findMobileAbout()
        this.findSignProductList()
        this.findMotionComicList()
        this.findDramaList()
        this.findSurrounding()
        this.findLinkList()
        this.findDesc()
        this.findBaseInfo()
    },
    methods: {
        onClickTab() {
            this.show = !this.show
        },
        async findBanner() {
            const res = await findBanner()

            this.banners = res
        },
        async findMobileAbout() {
            const res = await findMobileAbout()

            const [text, img] = res

            this.about = {
                content: text.configContent,
                image: img.configContent,
            }
        },
        async findSignProductList() {
            const params = {
                ...this.signPage,
            }

            const res = await findSignProductList(params)

            const { rows } = res

            this.signProduct = rows
        },
        async findMotionComicList() {
            const params = {
                pageNo: 1,
                pageSize: 100,
            }

            let res = await findMotionComicList(params)

            res = res.map((items) => {
                if (items.pageComicList.rows.length % 2 != 0) {
                    items.pageComicList.rows.pop()
                }
                return items
            })

            this.comicsTabs = res
        },
        async findDramaList() {
            const params = {
                pageNo: 1,
                pageSize: 100,
            }

            const res = await findDramaList(params)

            let { rows } = res

            if (rows.length % 3 != 0) {
                rows.pop()
            }

            this.dramas = rows || []
        },
        async findSurrounding() {
            const res = await findSurrounding()

            this.surrounding = res
        },
        async findLinkList() {
            const res = await findLinkList()

            this.links = res
        },
        async findDesc() {
            const res = await findDesc()

            res.forEach((items) => {
                this.desc[items.configKey] = {
                    configName: items.configName,
                    configContent: items.configContent,
                }
            })
        },
        async findBaseInfo() {
            const res = await findBaseInfo()

            res.forEach((items) => {
                this.baseInfo[items.configKey] = items
            })
        },
    },
}
</script>

<style lang="scss">
@import '../../../assets/css/mobile.scss';
.mobile {
    position: relative;
    text-align: left;
}

// .mobile-top-container {
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
// }
.mobile-top {
    width: 100vw;
    height: 48px;
    z-index: 11011;
    position: fixed;
    .logo-top {
        width: 94px;
        height: 28px;
        margin-top: 10px;
    }
    .top-tabs {
        width: 16px;
        height: 16px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            position: absolute;
            opacity: 0;
        }
        .mobile-menus {
            width: 80px;
            color: #666666;
            font-size: 12px;
            font-weight: 500;
            position: absolute;
            top: 25px;
            right: 0;
            background: #fff;
            text-align: center;
            padding: 8px 0;
            .mobile-menus-item + .mobile-menus-item {
                margin-top: 16px;
            }
        }

        .list {
            opacity: 1;
            transform: rotate(360deg);
            transition: all 0.5s;
        }

        .close {
            opacity: 1;
            transform: rotate(360deg);
            transition: all 0.5s;
        }
    }
}
.mobile-banner {
    position: fixed;
    width: 100vw;
    height: 211px;
    margin-top: 48px;
    img {
        width: 100%;
        height: 100%;
    }
}
.mobile-cont {
    position: absolute;
    left: 0;
    top: 280px;
    .mobile-about {
        .about-cont {
            margin-top: 24px;
            font-size: 12px;
            img {
                width: 100%;
                height: 172px;
                margin-top: 8px;
            }
        }
    }

    .mobile-scope {
        margin-top: 32px;
        .sign-tit {
            margin-top: 8px;
            font-size: 12px;
        }
        .scope-cont {
            margin-top: 24px;

            .sign {
                margin-top: 32px;
                color: #333;
                .sign-cont {
                    .sign-item {
                        margin-top: 16px;
                        display: flex;
                        padding: 8px;
                        box-sizing: border-box;
                        justify-content: space-between;
                        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
                        width: calc(100vw - 32px);
                        .comic-img {
                            width: 116px;
                            height: 154px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .sign-right {
                            width: calc(100% - 132px);
                            font-size: 12px;
                            color: #999999;
                            .signr-tit {
                                font-size: 14px;
                                color: #333333;
                            }
                            .sign-text {
                                margin-top: 6px;
                                width: 100%;
                                height: 120px;
                                text-align: justify;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 7;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
            }

            .dynamic {
                margin-top: 32px;
                .dynamic-container {
                    margin-top: 18px;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    grid-gap: 12px 12px;
                    grid-auto-rows: minmax(20px, auto);
                    width: calc(100vw - 32px);
                    .dynamic-container-item {
                        width: 100%;
                        height: 127px;
                        position: relative;
                        .motion-img {
                            width: 100%;
                            height: 103px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .dynamic-title {
                            width: 100%;
                            height: 24px;
                            background: #f5f5f5;
                            text-align: center;
                            line-height: 24px;
                            font-size: 12px;
                            color: #333;
                            font-weight: bold;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            padding: 0 10px;
                            box-sizing: border-box;
                        }
                        .dynamic-circle {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: rgba(0, 0, 0, 0.6);
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -80%);
                            text-align: center;
                            line-height: 28px;
                            .svg-icon {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                }
            }
            .drama {
                margin-top: 32px;
                .drama-container {
                    margin-top: 18px;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    grid-gap: 12px 12px;
                    grid-auto-rows: minmax(20px, auto);
                    width: calc(100vw - 32px);
                    .drama-container-item {
                        width: 100%;
                        // height: 107px;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
            }
            .surrounding {
                width: calc(100vw - 32px);
                margin-top: 32px;
                .surrounding-swipe {
                    margin-top: 16px;
                    width: 100%;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }
}

.mobile-footer {
    background: #232323;
    width: 100vw;
    padding: 16px 16px;
    box-sizing: border-box;
    margin-top: 16px;
    .mobile-footer-content {
        display: flex;
        align-items: center;
        img {
            width: 69px;
            height: 69px;
        }
        .mobile-footer-right {
            margin-left: 16px;
            .footer-tab {
                // display: flex;
                .footer-tab-item {
                    display: inline-block;
                    margin-right: 10px;
                    a {
                        display: inline-block;
                    }
                    img {
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        vertical-align: middle;
                    }
                    span {
                        color: #f5f5f5;
                        font-size: 11px;
                        font-weight: 500;
                    }
                }
            }
            .contact-container {
                margin-top: 15px;
                display: flex;
                //   justify-content: space-between;
                align-items: flex-end;
                .contact-left {
                    width: 198px;
                    color: #f5f5f5;
                    .contact-title {
                        font-size: 14px;
                        font-weight: 500;
                    }
                    .contact-item {
                        margin-top: 6px;
                        .svg-icon {
                            width: 14px;
                            height: 14px;
                            margin-right: 7px;
                        }
                        span {
                            font-size: 10px;
                        }
                    }
                }
                .contact-right {
                    width: 60px;
                    img {
                        width: 60px;
                        height: 35px;
                        object-fit: cover;
                    }
                    .join-title {
                        color: #f5f5f5;
                        font-size: 12px;
                        font-weight: 500;
                        margin-top: 4px;
                    }
                }
            }
        }
    }
    .mobile-footer-line {
        width: 100%;
        margin-top: 10px;
        box-sizing: border-box;
        div {
            width: 100%;
            border-top: 1px #333333 solid;
            color: #666666;
            font-size: 11px;
            font-weight: 500;
            padding-top: 7px;
            text-align: center;
        }
    }
}
</style>
